import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuthStore } from "../../../hooks";
import { styled } from '@mui/material/styles'
import { Nav } from "../../common/Nav/Nav";
import { Grid } from "@mui/material";
import { Role } from "../../../types/roles/roleTypes";
import { HeaderCustom } from "../../common/Header/HeaderCustom";

export const Layout: React.FC<any> = (): JSX.Element | any => {
    const { user } = useAuthStore();
    const userRole:Role|any = user.userType;

    const [openNew, setOpenNew] = useState(false)
    const APP_BAR_MOBILE = 64
    const APP_BAR_DESKTOP = (user.userType != Role.FAMILY) ? 80 : 0
    const HEIGHT_MAIN = (user.userType != Role.FAMILY) ?  `calc(100VH - ${75}px)` :  `calc(100VH - ${230}px)`

    const StyledRoot = styled('div')({
        display: (user.userType != Role.FAMILY) ? 'flex' : 'block',
        minHeight: '100%',
    });

    const Main = styled('div')(({ theme }) => ({
        flexGrow: 1,
        height: `calc(100VH - ${75}px)`,
        marginTop: APP_BAR_MOBILE,
        paddingTop: 10,
        background: 'rgb(250, 250, 251)',
        overflow:'scroll',
        overflowX: 'hidden',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),

        [theme.breakpoints.up('xs')]: {
            height: HEIGHT_MAIN,
            marginTop: APP_BAR_DESKTOP,
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingTop: 10,
            overflow:'scroll',
            overflowX: 'hidden',
        },
        [theme.breakpoints.up('sm')]: {
            height: `calc(100VH - ${75}px)`,
            marginTop: APP_BAR_DESKTOP,
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingTop: 10,
            overflow:'scroll',
            overflowX: 'hidden',
        },
        [theme.breakpoints.up('md')]: {
            height: `calc(100VH - ${75}px)`,
            marginTop: APP_BAR_DESKTOP,
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingTop: 10,
            overflow:'scroll',
            overflowX: 'hidden',
        },
    }));

    return (
        <>
        <StyledRoot>
            {
                [Role.SUPER_ADMIN, Role.ADMIN, Role.TENANT, Role.AGENT, Role.OWNER].includes(userRole) ? (
                    <Nav openNav={openNew} onCloseNav={() => setOpenNew(false)} />
                ) : (
                    <HeaderCustom />
                )
            }
            <Main >
                {
                    [Role.SUPER_ADMIN, Role.ADMIN, Role.TENANT, Role.AGENT, Role.OWNER].includes(userRole) ? (
                        <Grid sx={{ minHeight: 600, background: '#fff', borderRadius: 2, padding: 3}}>
                            <Outlet />
                        </Grid>
                    )
                    : (
                        <Grid sx={{ minHeight: 600, background: '#fff', borderRadius: 2}}>
                            <Outlet />
                        </Grid>
                    )
                }
            </Main>
        </StyledRoot>
        
        </>
    )
}